module.exports = __webpack_public_path__ + "static/media/19.895c5b86.jpg";